import { Button } from '@mui/material';
import { useEffect, useState } from 'react';

import { countryModel } from 'entities/country';
import { DiseaseDialog } from 'entities/disease';
import { userModel } from 'entities/user';

import { Disease, DiseaseListItem } from 'shared/api';

type DiseaseItem = Disease | DiseaseListItem;

type Props = {
  onSubmit: Function;
  isPets?: boolean;
  diseaseList: DiseaseItem[];
  isSuccess: boolean;
  isLoading: boolean;
};

export const CreateDisease = ({ onSubmit, isSuccess, isLoading, diseaseList, isPets = false }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: countriesData } = countryModel.useAllCountries();
  const { data } = userModel.useUser();

  // Маппим diseaseList для проверки уникальности имени
  const diseaseListMapped = diseaseList.map((d) => ({
    ...d,
    _id: 'id' in d ? d.id : d._id,
  })) as Disease[];

  useEffect(() => {
    if (isSuccess) setIsOpen(false);
  }, [isSuccess]);

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)} sx={{ alignSelf: 'end' }}>
        Add disease
      </Button>
      <DiseaseDialog
        title="Add disease"
        isPets={isPets}
        diseaseList={diseaseListMapped}
        countriesList={countriesData?.data ?? []}
        userRole={data?.role}
        isOpen={isOpen}
        isLoading={isLoading}
        onClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
      />
    </>
  );
};
